module.exports = __webpack_public_path__ + "static/img/v70DetailImg.7314bbb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/v70DetailImg.png
// module id = EP7b
// module chunks = 1